import { Link } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { MotoMaintenancePanel } from "../components/MotoMaintenancePanel";
import { LanguageSwitcher } from "../components/LanguageSwitcher";
import Landing from "./Landing";
import wzLogo from "../assets/workzone-logo.png";

export default function MotoMaintenancePage() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }

  if (!user) return <Landing />;

  if (user.kind === "employee" || user.kind === "marketer") {
    return (
      <div dir="rtl" className="min-h-screen flex items-center justify-center p-6 text-center">
        <p className="text-slate-500">هذه الصفحة متاحة لحساب الإدارة فقط.</p>
      </div>
    );
  }

  return (
    <div dir="rtl" className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-20 bg-white/90 backdrop-blur border-b border-slate-200">
        <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <div className="h-10 w-10 rounded-xl bg-white border border-slate-200 flex items-center justify-center p-1">
              <img src={wzLogo} alt="WorkZone" className="h-full w-full object-contain" />
            </div>
            <div>
              <p className="font-heading font-extrabold leading-tight">صيانة الدراجات النارية</p>
              <p className="text-[11px] text-slate-400 leading-tight">WorkZone · {user.org_name || "لوحة الصيانة"}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <LanguageSwitcher />
            <Link
              to="/"
              data-testid="moto-maint-back"
              className="flex items-center gap-1.5 text-sm font-semibold text-blue-600 hover:text-blue-700 rounded-lg px-3 py-2 hover:bg-blue-50 transition-colors"
            >
              <span className="hidden sm:inline">لوحة التحكم</span> <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-4 py-6" data-testid="moto-maintenance-page">
        <MotoMaintenancePanel />
      </main>
    </div>
  );
}
